/**
 * @module theme/toastTheme
 * @description react-hot-toast options mapped to CriticAI design tokens (CSS variables).
 */

export const toastOptions = {
  duration: 4000,
  style: {
    background: 'rgba(20, 22, 31, 0.96)',
    color: 'var(--critic-text-primary)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: 'var(--critic-radius-md)',
    backdropFilter: 'blur(20px)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.35)',
  },
};
